"use client";

import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex gap-6">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-foreground/70 hover:text-foreground hover:underline underline-offset-4 transition-colors duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const currentYear = new Date().getFullYear();
  return <footer ref={ref} className={`bg-background border-t border-border py-8 transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-sm text-foreground/60">
            © {currentYear} Omni Wealth management. All rights reserved.
          </div>

          <MenuProvider menu_id="6" className="flex-1 flex justify-center">
            <FooterNavigation />
          </MenuProvider>

          
        </div>
      </div>
    </footer>;
}